var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryKh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8985)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8985",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8985)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H28V0H0V5.33333Z",
    fill: "#0F3EB6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V14.6666H0V20Z",
    fill: "#0F3EB6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.6667H28V5.33337H0V14.6667Z",
    fill: "#ED1A3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 8.72725H13.3334V8.00004C13.3334 7.63185 13.6319 7.33337 14.0001 7.33337C14.3683 7.33337 14.6667 7.63185 14.6667 8.00004V8.72725H16.0001V10H12.0001V8.72725ZM17.3334 8.00004C16.9652 8.00004 16.6667 8.29852 16.6667 8.66671V9.33337C16.6667 9.70156 16.9652 10 17.3334 10C17.7016 10 18.0001 9.70156 18.0001 9.33337V8.66671C18.0001 8.29852 17.7016 8.00004 17.3334 8.00004ZM11.3334 13.3334V10.6667H10.0001L8.66675 13.3334H11.3334ZM16.0001 10.6667H12.0001V13.3334H16.0001V10.6667ZM16.6667 10.6667H18.0001L19.3334 13.3334H16.6667V10.6667ZM10.6667 8.00004C10.2986 8.00004 10.0001 8.29852 10.0001 8.66671V9.33337C10.0001 9.70156 10.2986 10 10.6667 10C11.0349 10 11.3334 9.70156 11.3334 9.33337V8.66671C11.3334 8.29852 11.0349 8.00004 10.6667 8.00004Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8985"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryKh);
export default __webpack_public_path__ + "static/media/Country=KH.d1958564ef67ffcc33cb6a189a752b16.svg";
export { ForwardRef as ReactComponent };